module.exports = __webpack_public_path__ + "img/dialog_image_S202P_WX1HX1PX1.b27eafd4.png";